import { Component } from '@angular/core';
import { ServicesService } from 'src/services/services.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-push-notification',
  templateUrl: './push-notification.component.html',
  styleUrls: ['./push-notification.component.scss'],
  standalone: false
})
export class PushNotificationComponent {
  title: any;
  msg: any;
  eventId: any;

  constructor(
    private service: ServicesService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.eventId = sessionStorage.getItem('Event_ID');
  }

  SendPush() {
    if (!this.title || !this.title.trim()) {
      this.toastr.warning('Please Enter Title');
      return;
    }

    if (!this.msg || !this.msg.trim()) {
      this.toastr.warning('Please Enter Message');
      return;
    }

    const MessageData = {
      title: this.title,
      msg: this.msg,
      event_id: this.eventId,
    }

    this.service.send_push(MessageData).subscribe(
      (data: any) => {
        if (data.id) {
          this.toastr.success('Message Sent Successfully');
        } else {
          this.toastr.error('Message Not Sent');
        }
      }
    )
  }

}
